import { useEffect } from "react";

// Warn before the browser navigates away (reload, tab/window close, or typing a
// new URL) while a form has unsaved changes — the native "Leave site?" prompt.
//
// Limitation: this does NOT intercept in-app React Router navigation (sidebar,
// breadcrumbs, back buttons). That needs a data router + useBlocker, which this
// app (plain BrowserRouter) isn't set up for yet — tracked as a follow-up. Only
// wire this where a real dirty flag exists (the rich editors can't cheaply tell).
export function useUnsavedGuard(isDirty) {
  useEffect(() => {
    if (!isDirty) return undefined;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = ""; // Chrome requires returnValue to be set.
      return "";
    };
    window.addEventListener("beforeunload", handler);
    return () => window.removeEventListener("beforeunload", handler);
  }, [isDirty]);
}
